import React from 'react'

function Footer() {
  return (
    <div className='footer'>
        <p> Copyrighted © 2023, Quiz Quest </p>
    </div>
  )
}

export default Footer